import { render } from "./Providers.vue?vue&type=template&id=e50f9774&scoped=true"
const script = {}

import "./Providers.vue?vue&type=style&index=0&id=e50f9774&scoped=true&lang=css"

import exportComponent from "/home/runner/work/multiCotizadorCR/multiCotizadorCR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e50f9774"]])

export default __exports__